export enum MjxTableEventsEnum {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  SCROLL_END = 'scroll_end',
  EXPAND_ROW = 'expand_row'
}
